// extracted by mini-css-extract-plugin
module.exports = {"hero":"features-main_hero__9EVkm"};